module.exports = __webpack_public_path__ + "static/media/profile.1bf6f473.PNG";